import { useLocation, useNavigate } from "react-router-dom";
import { TrendingUp, Tag, Briefcase, Wallet, User, Camera } from "lucide-react";
import { motion } from "framer-motion";
import { useState } from "react";
import { SnapToPriceModal } from "@/components/valuation/SnapToPriceModal";
import { useMobileNavVisible } from "@/hooks/useMobileNavVisible";

const navItems = [
  { path: "/markets", label: "Markets", icon: TrendingUp },
  { path: "/sell", label: "Sell", icon: Tag },
  { path: "__scan__", label: "Scan", icon: Camera, isScan: true },
  { path: "/portfolio", label: "Portfolio", icon: Briefcase },
  { path: "/profile", label: "Profile", icon: User },
];

export function MobileBottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const visible = useMobileNavVisible();
  const [snapOpen, setSnapOpen] = useState(false);

  if (!visible) {
    return null;
  }

  const isActive = (path: string) => {
    if (path === "__scan__") return false;
    if (path === "/profile") return location.pathname === "/profile" || location.pathname === "/settings";
    return location.pathname === path;
  };

  const handleTap = (item: typeof navItems[number]) => {
    // Haptic feedback
    if (navigator.vibrate) {
      navigator.vibrate(10);
    }
    if (item.isScan) {
      setSnapOpen(true);
    } else {
      navigate(item.path);
    }
  };

  return (
    <>
      <nav className="fixed bottom-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-lg border-t border-border md:hidden"
        style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
      >
        <div className="flex items-center justify-around h-16 px-2">
          {navItems.map((item) => {
            const active = isActive(item.path);

            if (item.isScan) {
              return (
                <button
                  key={item.path}
                  onClick={() => handleTap(item)}
                  className="relative flex flex-col items-center justify-center gap-0.5 flex-1 h-full"
                >
                  <div className="flex items-center justify-center w-12 h-12 -mt-5 rounded-full bg-primary text-primary-foreground shadow-lg active:scale-95 transition-transform">
                    <Camera className="h-6 w-6" />
                  </div>
                  <span className="text-[10px] font-medium text-primary -mt-0.5">
                    {item.label}
                  </span>
                </button>
              );
            }

            return (
              <button
                key={item.path}
                onClick={() => handleTap(item)}
                className="relative flex flex-col items-center justify-center gap-0.5 flex-1 h-full transition-colors"
              >
                {active && (
                  <motion.div
                    layoutId="bottomNavIndicator"
                    className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-primary rounded-full"
                    transition={{ type: "spring", stiffness: 500, damping: 35 }}
                  />
                )}
                <item.icon
                  className={`h-5 w-5 transition-colors ${
                    active ? "text-primary" : "text-muted-foreground"
                  }`}
                />
                <span
                  className={`text-[10px] font-medium transition-colors ${
                    active ? "text-primary" : "text-muted-foreground"
                  }`}
                >
                  {item.label}
                </span>
              </button>
            );
          })}
        </div>
      </nav>
      <SnapToPriceModal open={snapOpen} onOpenChange={setSnapOpen} />
    </>
  );
}
